export default __webpack_public_path__ + "static/problem_3-b1054ec57c1f98c6d2bd581bace4bc59.png";